import { CreateDocumentaryRequest, CreateDocumentaryResponse, Documentary } from '@/types/model';
import { apiClient, QueryParams, PaginatedResponse } from './apiClient';

export interface DocumentaryQueryParams extends QueryParams {
  active?: boolean;
  categoryId?: string;
  year?: number;
  kidsContent?: boolean;
}

export const documentaryService = {
  /**
   * Get documentaries with pagination, search, and filtering
   */
  async getDocumentaries(params: DocumentaryQueryParams = {}): Promise<PaginatedResponse<Documentary>> {
    return apiClient.getPaginated<Documentary>('/documentaries', params);
  },

  /**
   * Get a single documentary by ID
   */
  async getDocumentaryById(id: string): Promise<Documentary> {
    return apiClient.getById<Documentary>('/documentaries', id);
  },

  /**
   * Create a new documentary
   */
  async createDocumentary(documentaryData: CreateDocumentaryRequest): Promise<CreateDocumentaryResponse> {
    return apiClient.create<CreateDocumentaryRequest, CreateDocumentaryResponse>('/documentaries', documentaryData);
  },

  /**
   * Update a documentary
   */
  async updateDocumentary(id: string, documentaryData: Partial<CreateDocumentaryRequest>): Promise<CreateDocumentaryResponse> {
    return apiClient.update<Partial<CreateDocumentaryRequest>, CreateDocumentaryResponse>('/documentaries', id, documentaryData);
  },

  /**
   * Delete a documentary
   */
  async deleteDocumentary(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.deleteById<{ success: boolean; message: string }>('/documentaries', id);
  },

  /**
   * Toggle documentary active status
   */
  async toggleDocumentaryStatus(id: string, active: boolean): Promise<CreateDocumentaryResponse> {
    return apiClient.toggleStatus<CreateDocumentaryResponse>('/documentaries', id, active);
  },
};